import ExternalCity from '@/bundles/GroupFilters/models/ExternalCity';

export default class ExternalToMapper {
  mapToModel (data: any): ExternalCity {
    const city = new ExternalCity();

    city.name = data.name;
    city.region = data.region;
    city.country = data.country;
    city.country_code = data.country_code;

    return city;
  }
}
